import { store } from '@betacrew/jars-flux';

export const componentKey = "BILL_SWITCH";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setOrganizationDetails: (state, action) => {
            state.organizationDetails = action.payload;
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setFormAndTaxYearList: (state, action) => {
            state.formAndTaxYearList = action.payload;
        },
        setIsImportDataGridViewLoaded: (state, action) => {
            state.isImportDataGridViewLoaded = action.payload;
        },
        setImportData: (state, action) => {
            state.importData = action.payload;
        },
        setFormSettings: (state, action) => {
            state.formSettings = action.payload;
        },
    },
    initialReducerState: {
        organizationDetails: [],
        loadingState: false,
        formAndTaxYearList: {},
        importData: null,
        isImportDataGridViewLoaded: false,
        formSettings: null,
    }
});
export const { setOrganizationDetails, setLoadingState, setFormAndTaxYearList, setIsImportDataGridViewLoaded, setImportData, setFormSettings } = actions;